import { render, staticRenderFns } from "./AjoutMonteIA.vue?vue&type=template&id=5486d3dc&"
import script from "./AjoutMonteIA.vue?vue&type=script&lang=js&"
export * from "./AjoutMonteIA.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports